import moment from "moment";
import { CurrencyFormat } from "../../../../../components/helpers";

export const convertNotYetDisbursed = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      dateTime: moment(item.created_at).format("DD/MM/YYYY HH:mm") || "-",
      customerName: item.customer_name || "-",
      sbg: item.sbg_code || "-",
      loanAmount: `Rp ${CurrencyFormat(item.loan_amount)}` || "0",

      totalInterest:
        `Rp ${CurrencyFormat(
          item.capital_loan > 0 ? item.capital_loan : item.loan_amount
        )}` || "0",

      commission:
        `${
          item.capital_loan > 0
            ? item.percent_capital_loan
            : item.percent_loan_amount
        } %` || "-",
      commissionValue: `Rp ${CurrencyFormat(item.amount)}` || "0",
      commissionNumber: item.amount || 0,
    });
  });
  return converted;
};
